// Test IDs for the NuRegen marketing site
export const HOME = {
        emergentLink: 'home-emergent-link',
};

export const NAV = {
        root: 'nav-root',
        logo: 'nav-logo',
        linkSolution: 'nav-link-solution',
        linkTech: 'nav-link-tech',
        linkProcess: 'nav-link-process',
        linkClock: 'nav-link-clock',
        linkGallery: 'nav-link-gallery',
        linkAbout: 'nav-link-about',
        partnerBtn: 'nav-partner-btn',
};

export const HERO = {
        root: 'hero-root',
        watchBtn: 'hero-watch-mission-btn',
};

export const SECTIONS = {
        whoWeAre: 'section-who-we-are',
        didYouKnow: 'section-did-you-know',
        problem: 'section-problem',
        clock: 'section-carbon-clock',
        clockNumber: 'carbon-clock-number',
        solution: 'section-solution',
        tech: 'section-tech',
        process: 'section-process',
        pillars: 'section-pillars',
        partners: 'section-partners',
        gallery: 'section-gallery',
        footer: 'section-footer',
};

export const CONTACT = {
        form: 'contact-form',
        name: 'contact-name',
        email: 'contact-email',
        company: 'contact-company',
        message: 'contact-message',
        submit: 'contact-submit-btn',
        success: 'contact-success',
        error: 'contact-error',
};
